export default __webpack_public_path__ + "static/media/IconDesc_ColorCartridge.256.7110c784.png";